import { isServer } from '../env-helper';

type MessageType =
  | ShowAlertMessage
  | ShowChartPatternBottomSheetMessage
  | ShowSnackbarMessage
  | showBonusEducationPopupMessage
  | UpdateIndicatorAreaHeight
  | ChartTradeInteractionMessage;

interface ShowAlertMessage extends Record<string, unknown> {
  name: 'showAlert';
  callback: 'onShowAlertResult';
  params: {
    title: string;
    content: string;
    positive_button: string;
    negative_button: string | null;
  };
}

interface ShowSnackbarMessage extends Record<string, unknown> {
  name: 'showSnackbar';
  callback: 'onShowSnackbarResult';
  params: {
    icon: 'SUCCESS' | 'WARNING' | 'ERROR';
    message: string;
    button: null | {
      text: string;
      page: string; // locator
    };
  };
}

interface ShowChartPatternBottomSheetMessage extends Record<string, unknown> {
  name: 'showChartPatternExplanationBottomSheet';
  callback: 'onShowChartPatternExplanationResult';
  params: {
    title: string;
    url: string;
    content: string;
  };
}

interface showBonusEducationPopupMessage extends Record<string, unknown> {
  name: 'erd78TradeNow' | 'erd78SetPositionMode';
  callback: string | null;
  params: {};
}

interface UpdateIndicatorAreaHeight extends Record<string, unknown> {
  name: 'updateIndicatorAreaHeight';
  callback: '';
  params: {
    height: number;
  };
}

/**
 * 차트 기반 TP/SL & 포지션 관리 (ERD-234, Flow A~D).
 * 모바일 webview에서 web이 제스처를 감지하면 이 메시지로 native에 확인 UI 표시·실행을 위임한다.
 *
 * ⚠️ wire 포맷(params 중첩 / callback 이름)은 ERD 컨트랙트를 기존 simple-bridge 패턴에 맞춰
 * *가정* 한 것 — 모바일 엔지니어와 추후 합의 필요.
 */
export interface ChartTradeInteractionMessage extends Record<string, unknown> {
  name: 'chartTradeInteraction';
  callback: 'onChartTradeInteractionResult';
  params: {
    type: 'CREATE_TPSL' | 'MODIFY_TPSL' | 'DELETE_TPSL' | 'CLOSE_POSITION';
    symbol: string;
    slot: number;
    /** *_TPSL 용. */
    lineType?: 'TP' | 'SL';
    /** MODIFY/DELETE 용 — 기존 조건부 주문 id. */
    orderId?: string;
    /** CREATE/MODIFY — 제스처 종료 시 라인 가격(web이 tick 정렬). */
    triggerPrice?: string;
  };
}

export const canSendNativeRequest =
  !isServer && Boolean(window.AndroidPrexSimpleBridge || window.webkit?.messageHandlers?.iOSPrexSimpleBridge);

export const sendNativeRequest = (message: MessageType) => {
  if (window.AndroidPrexSimpleBridge) {
    window.AndroidPrexSimpleBridge.postMessage(JSON.stringify(message));
  } else if (window.webkit?.messageHandlers?.iOSPrexSimpleBridge) {
    window.webkit.messageHandlers.iOSPrexSimpleBridge.postMessage(message);
  }
};
